<template>
  <div class="g-map-wrapper" :class="{ 'hide-leaflet-draw-toolbar': router.path === '/layer' }">
    <!-- 地图区域 -->
    <div id="g-container" :style="{ width: '100%', height: '100%' }" />
    <!-- 绘制面板 -->
    <div
      class="g-action-panel"
      :style="{ right: drawVisible ? '316px' : '16px', display: router.path === '/layer' ? 'flex' : 'none' }"
    >
      <div
        :class="
          state.currentType === 'pin'
            ? 'g-action-item selection'
            : 'g-action-item'
        "
        @click="draw('pin', true)"
      >
        <a><a-image :src="pin" :preview="false" /></a>
      </div>
      <div
        :class="
          state.currentType === 'polyline'
            ? 'g-action-item selection'
            : 'g-action-item'
        "
        @click="draw('polyline', true)"
      >
        <a><LineOutlined :rotate="135" class="fz20" /></a>
      </div>
      <div
        :class="
          state.currentType === 'polygon' && !state.isFlightArea
            ? 'g-action-item selection'
            : 'g-action-item'
        "
        @click="draw('polygon', true)"
      >
        <a><BorderOutlined class="fz18" /></a>
      </div>
      <FlightAreaActionIcon
        class="g-action-item mt10"
        :class="{ selection: mouseMode && state.isFlightArea }"
        @select-action="selectFlightAreaAction"
        @click="selectFlightAreaAction"
      />
      <div v-if="mouseMode" class="g-action-item" @click="draw('off', false)">
        <a style="color: red"><CloseOutlined /></a>
      </div>
    </div>

    <!-- Map Type Switcher -->
    <div class="map-type-switcher">
      <div style="display: flex; align-items: center; gap: 8px">
        <a-dropdown overlayClassName="map-type-dropdown">
          <a-button type="primary" size="small" style="background-color: green">
            {{ currentMapType }}
          </a-button>
          <template #overlay>
            <a-menu @click="handleMapTypeChange">
              <!-- Non-clickable header -->
              <a-menu-item key="layers" disabled>
                <span style="font-weight: 600; color: #6b7280; cursor: default">
                  Layers
                </span>
              </a-menu-item>

              <!-- Options -->
              <a-menu-item key="voyager">
                <span
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 140px;
                  "
                >
                  Street (EN)
                  <span
                    v-if="currentMapType === 'Street (EN)'"
                    style="color: #22c55e; font-weight: bold"
                    >✔</span
                  >
                </span>
              </a-menu-item>

              <a-menu-item key="osm">
                <span
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 140px;
                  "
                >
                  OpenStreetMap
                  <span
                    v-if="currentMapType === 'OpenStreetMap'"
                    style="color: #22c55e; font-weight: bold"
                    >✔</span
                  >
                </span>
              </a-menu-item>

              <a-menu-item key="satellite">
                <span
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 140px;
                  "
                >
                  Satellite
                  <span
                    v-if="currentMapType === 'Satellite'"
                    style="color: #22c55e; font-weight: bold"
                    >✔</span
                  >
                </span>
              </a-menu-item>

              <a-menu-item key="terrain">
                <span
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 140px;
                  "
                >
                  Terrain
                  <span
                    v-if="currentMapType === 'Terrain'"
                    style="color: #22c55e; font-weight: bold"
                    >✔</span
                  >
                </span>
              </a-menu-item>

              <a-menu-item key="dark">
                <span
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 140px;
                  "
                >
                  Dark
                  <span
                    v-if="currentMapType === 'Dark'"
                    style="color: #22c55e; font-weight: bold"
                    >✔</span
                  >
                </span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
        <a-button size="small" @click="locateMe"> &#9965; Locate Me</a-button>
        <div v-if="router.name === 'area-route'">
          <button
            :disabled="!polygonState.isPolygonFormed"
            :style="{
              backgroundColor: polygonState.isPolygonFormed
                ? '#22c55e'
                : '#9ca3af' /* green-500 vs gray-400 */,
              color: 'white',
              cursor: polygonState.isPolygonFormed ? 'pointer' : 'not-allowed',
              opacity: 1,
              border: 'none',
              borderRadius: '9999px' /* fully rounded */,
              padding: '5px 10px',
              fontSize: '16px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: polygonState.isPolygonFormed
                ? '0 4px 12px rgba(34,197,94,0.4)'
                : '0 2px 6px rgba(156,163,175,0.4)',
            }"
            @click="handleClickMe"
          >
            ✔
          </button>
        </div>
        <div v-if="router.path === '/set-waypoints'">
          <button
            @click="handleDeleteLastWaypoint()"
            :disabled="setWaypointState.waypointsDetails.length === 0"
            :style="{
              backgroundColor:
                setWaypointState.waypointsDetails.length != 0
                  ? '#22c55e'
                  : '#9ca3af' /* green-500 vs gray-400 */,
              color: 'white',
              cursor:
                setWaypointState.waypointsDetails.length != 0
                  ? 'pointer'
                  : 'not-allowed',
              opacity: 1,
              border: 'none',
              borderRadius: '9999px' /* fully rounded */,
              padding: '5px 10px',
              fontSize: '16px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow:
                setWaypointState.waypointsDetails.length != 0
                  ? '0 4px 12px rgba(34,197,94,0.4)'
                  : '0 2px 6px rgba(156,163,175,0.4)',
            }"
          >
            <img
              src="../assets/icons/delete.png"
              alt=""
              style="width: 18px; height: 18px"
            />
          </button>
        </div>
      </div>
    </div>
    <!-- 飞机OSD -->
    <div
      v-if="osdVisible.visible && !osdVisible.is_dock"
      v-drag-window
      class="osd-panel fz12"
    >
      <div
        class="drag-title pl5 pr5 flex-align-center flex-row flex-justify-between"
        style="border-bottom: 1px solid #515151; height: 18%"
      >
        <span>{{ osdVisible.callsign }}</span>
        <span
          ><a
            class="fz16"
            style="color: white"
            @click="() => (osdVisible.visible = false)"
            ><CloseOutlined /></a
        ></span>
      </div>
      <div style="height: 82%">
        <div
          class="flex-column flex-align-center flex-justify-center"
          style="
            margin-top: -5px;
            padding-top: 25px;
            float: left;
            width: 60px;
            background: #2d2d2d;
          "
        >
          <a-tooltip :title="osdVisible.model">
            <div
              style="width: 90%"
              class="flex-column flex-align-center flex-justify-center"
            >
              <span><a-image :src="M30" :preview="false" /></span>
              <span>{{ osdVisible.model }}</span>
            </div>
          </a-tooltip>
        </div>
        <div class="osd">
          <a-row>
            <a-col
              span="16"
              :style="
                deviceInfo.device.mode_code === EModeCode.Disconnected
                  ? 'color: red; font-weight: 700;'
                  : 'color: rgb(25,190,107)'
              "
              >{{ EModeCode[deviceInfo.device.mode_code] }}</a-col
            >
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Signal strength">
                <span>HD</span>
                <span class="ml10">{{
                  deviceInfo.gateway?.transmission_signal_quality
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="RC Battery Level">
                <span><ThunderboltOutlined class="fz14" /></span>
                <span class="ml10">{{
                  deviceInfo.gateway &&
                  deviceInfo.gateway.capacity_percent !== str
                    ? deviceInfo.gateway?.capacity_percent + " %"
                    : deviceInfo.gateway?.capacity_percent
                }}</span>
              </a-tooltip>
            </a-col>

            <a-col span="6">
              <a-tooltip title="Drone Battery Level">
                <span><ThunderboltOutlined class="fz14" /></span>
                <span class="ml10">{{
                  deviceInfo.device.battery.capacity_percent !== str
                    ? deviceInfo.device.battery.capacity_percent + " %"
                    : deviceInfo.device.battery.capacity_percent
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-tooltip title="RTK Fixed">
              <a-col
                span="6"
                class="flex-row flex-align-center flex-justify-start"
              >
                <span>Fixed</span>
                <span
                  class="ml10 circle"
                  :style="
                    deviceInfo.device.position_state.is_fixed === 1
                      ? 'backgroud: rgb(25,190,107);'
                      : ' background: red;'
                  "
                ></span>
              </a-col>
            </a-tooltip>
            <a-col span="6">
              <a-tooltip title="GPS">
                <span>GPS</span>
                <span class="ml10">{{
                  deviceInfo.device.position_state.gps_number
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="RTK">
                <span><TrademarkOutlined class="fz14" /></span>
                <span class="ml10">{{
                  deviceInfo.device.position_state.rtk_number
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Flight Mode">
                <span><ControlOutlined class="fz16" /></span>
                <span class="ml10">{{ EGear[deviceInfo.device.gear] }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Altitude above sea level">
                <span>ASL</span>
                <span class="ml10">{{
                  deviceInfo.device.height === str
                    ? str
                    : deviceInfo.device.height.toFixed(2) + " m"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Altitude above takeoff level">
                <span>ALT</span>
                <span class="ml10">{{
                  deviceInfo.device.elevation === str
                    ? str
                    : deviceInfo.device.elevation.toFixed(2) + " m"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Distance to Home Point">
                <span>H</span>
                <span class="ml10">{{
                  deviceInfo.device.home_distance === str
                    ? str
                    : deviceInfo.device.home_distance.toFixed(2) + " m"
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Horizontal Speed">
                <span>H.S</span>
                <span class="ml10">{{
                  deviceInfo.device.horizontal_speed === str
                    ? str
                    : deviceInfo.device.horizontal_speed.toFixed(2) + " m/s"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Vertical Speed">
                <span>V.S</span>
                <span class="ml10">{{
                  deviceInfo.device.vertical_speed === str
                    ? str
                    : deviceInfo.device.vertical_speed.toFixed(2) + " m/s"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Wind Speed">
                <span>W.S</span>
                <span class="ml10">{{
                  deviceInfo.device.wind_speed === str
                    ? str
                    : (deviceInfo.device.wind_speed / 10).toFixed(2) + " m/s"
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
        </div>
      </div>
      <div
        class="battery-slide"
        v-if="deviceInfo.device.battery.remain_flight_time !== 0"
      >
        <div style="background: #535759" class="width-100"></div>
        <div
          class="capacity-percent"
          :style="{ width: deviceInfo.device.battery.capacity_percent + '%' }"
        ></div>
        <div
          class="return-home"
          :style="{ width: deviceInfo.device.battery.return_home_power + '%' }"
        ></div>
        <div
          class="landing"
          :style="{ width: deviceInfo.device.battery.landing_power + '%' }"
        ></div>
        <div
          class="white-point"
          :style="{ left: deviceInfo.device.battery.landing_power + '%' }"
        ></div>
        <div
          class="battery"
          :style="{ left: deviceInfo.device.battery.capacity_percent + '%' }"
        >
          {{ Math.floor(deviceInfo.device.battery.remain_flight_time / 60) }}:
          {{ 10 > deviceInfo.device.battery.remain_flight_time % 60 ? "0" : ""
          }}{{ deviceInfo.device.battery.remain_flight_time % 60 }}
        </div>
      </div>

      <DroneControlPanel
        :sn="osdVisible.gateway_sn"
        :deviceInfo="deviceInfo"
        :payloads="osdVisible.payloads"
      ></DroneControlPanel>
    </div>
    <!-- 机场OSD -->
    <div
      v-if="osdVisible.visible && osdVisible.is_dock"
      v-drag-window
      class="osd-panel fz12"
    >
      <div
        class="drag-title fz16 pl5 pr5 flex-align-center flex-row flex-justify-between"
        style="border-bottom: 1px solid #515151; height: 10%"
      >
        <span>{{ osdVisible.gateway_callsign }}</span>
      </div>
      <span
        ><a
          style="color: white; position: absolute; top: 5px; right: 5px"
          @click="() => (osdVisible.visible = false)"
          ><CloseOutlined /></a
      ></span>
      <!-- 机场 -->
      <div class="flex-display" style="border-bottom: 1px solid #515151">
        <div
          class="flex-column flex-align-stretch flex-justify-center"
          style="width: 60px; background: #2d2d2d"
        >
          <a-tooltip :title="osdVisible.model">
            <div
              class="flex-column flex-align-center flex-justify-center"
              style="width: 90%"
            >
              <span><RobotFilled style="font-size: 48px" /></span>
              <span class="mt10">Dock</span>
            </div>
          </a-tooltip>
        </div>
        <div class="osd flex-1" style="flex: 1">
          <a-row>
            <a-col
              span="16"
              :style="
                deviceInfo.dock.basic_osd?.mode_code ===
                EDockModeCode.Disconnected
                  ? 'color: red; font-weight: 700;'
                  : 'color: rgb(25,190,107)'
              "
            >
              {{ EDockModeCode[deviceInfo.dock.basic_osd?.mode_code] }}</a-col
            >
          </a-row>
          <a-row>
            <a-col span="12">
              <a-tooltip title="Accumulated Running Time">
                <span><HistoryOutlined /></span>
                <span class="ml10">
                  <span v-if="deviceInfo.dock.work_osd?.acc_time >= 2592000">
                    {{
                      Math.floor(deviceInfo.dock.work_osd?.acc_time / 2592000)
                    }}m
                  </span>
                  <span
                    v-if="deviceInfo.dock.work_osd?.acc_time % 2592000 >= 86400"
                  >
                    {{
                      Math.floor(
                        (deviceInfo.dock.work_osd?.acc_time % 2592000) / 86400
                      )
                    }}d
                  </span>
                  <span
                    v-if="
                      (deviceInfo.dock.work_osd?.acc_time % 2592000) % 86400 >=
                      3600
                    "
                  >
                    {{
                      Math.floor(
                        ((deviceInfo.dock.work_osd?.acc_time % 2592000) %
                          86400) /
                          3600
                      )
                    }}h
                  </span>
                  <span
                    v-if="
                      ((deviceInfo.dock.work_osd?.acc_time % 2592000) % 86400) %
                        3600 >=
                      60
                    "
                  >
                    {{
                      Math.floor(
                        (((deviceInfo.dock.work_osd?.acc_time % 2592000) %
                          86400) %
                          3600) /
                          60
                      )
                    }}min
                  </span>
                  <span
                    >{{
                      Math.floor(
                        (((deviceInfo.dock.work_osd?.acc_time % 2592000) %
                          86400) %
                          3600) %
                          60
                      )
                    }}
                    s</span
                  >
                </span>
              </a-tooltip>
            </a-col>
            <a-col span="12">
              <a-tooltip title="Activation time">
                <span><FieldTimeOutlined /></span>
                <span class="ml10"
                  >{{
                    new Date(
                      (deviceInfo.dock.work_osd?.activation_time ?? 0) * 1000
                    ).toLocaleString()
                  }}
                </span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Network State">
                <span :style="qualityStyle">
                  <span
                    v-if="
                      deviceInfo.dock.basic_osd?.network_state?.type ===
                      NetworkStateTypeEnum.FOUR_G
                    "
                    ><SignalFilled
                  /></span>
                  <span v-else><GlobalOutlined /></span>
                </span>
                <span class="ml10"
                  >{{
                    deviceInfo.dock.basic_osd?.network_state?.rate
                  }}
                  kb/s</span
                >
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip
                title="The total number of times the dock has performed missions."
              >
                <span><CarryOutOutlined /></span>
                <span class="ml10"
                  >{{ deviceInfo.dock.work_osd?.job_number }}
                </span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Media File Remain Upload">
                <span><CloudUploadOutlined class="fz14" /></span>
                <span class="ml10">{{
                  deviceInfo.dock.link_osd?.media_file_detail?.remain_upload
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip>
                <template #title>
                  <p>total: {{ deviceInfo.dock.basic_osd?.storage?.total }}</p>
                  <p>used: {{ deviceInfo.dock.basic_osd?.storage?.used }}</p>
                </template>
                <span><FolderOpenOutlined /></span>
                <span
                  class="ml10"
                  v-if="deviceInfo.dock.basic_osd?.storage?.total > 0"
                >
                  <a-progress
                    type="circle"
                    :width="20"
                    :percent="
                      (deviceInfo.dock.basic_osd?.storage?.used * 100) /
                      deviceInfo.dock.basic_osd?.storage?.total
                    "
                    :strokeWidth="20"
                    :showInfo="false"
                    :strokeColor="
                      (deviceInfo.dock.basic_osd?.storage?.used * 100) /
                        deviceInfo.dock.basic_osd?.storage?.total >
                      80
                        ? 'red'
                        : '#00ee8b'
                    "
                  />
                </span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Wind Speed">
                <span>W.S</span>
                <span class="ml10">{{
                  (deviceInfo.dock.basic_osd?.wind_speed ?? str) + " m/s"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Rainfall">
                <span>🌧</span>
                <span class="ml10">{{
                  RainfallEnum[deviceInfo.dock.basic_osd?.rainfall]
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Environment Temperature">
                <span>°C</span>
                <span class="ml10">{{
                  deviceInfo.dock.basic_osd?.environment_temperature
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Dock Temperature">
                <span>°C</span>
                <span class="ml10">{{
                  deviceInfo.dock.basic_osd?.temperature
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Dock Humidity">
                <span>💦</span>
                <span class="ml10">{{
                  deviceInfo.dock.basic_osd?.humidity
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Working Voltage">
                <span
                  style="
                    border: 1px solid;
                    border-radius: 50%;
                    width: 18px;
                    height: 18px;
                    line-height: 16px;
                    text-align: center;
                    float: left;
                  "
                  >V</span
                >
                <span class="ml10">{{
                  (deviceInfo.dock.work_osd?.working_voltage ?? str) + " mV"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Working Current">
                <span
                  style="
                    border: 1px solid;
                    border-radius: 50%;
                    width: 18px;
                    height: 18px;
                    line-height: 15px;
                    text-align: center;
                    float: left;
                  "
                  >A</span
                >
                <span class="ml10">{{
                  (deviceInfo.dock.work_osd?.working_current ?? str) + " mA"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Drone in dock">
                <span><RocketOutlined /></span>
                <span class="ml10">{{
                  deviceInfo.dock.basic_osd?.drone_in_dock
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row class="p5">
            <a-col span="24">
              <a-button
                type="primary"
                :disabled="dockControlPanelVisible"
                size="small"
                @click="setDockControlPanelVisible(true)"
              >
                Actions
              </a-button>
            </a-col>
          </a-row>
          <!-- 机场控制面板 -->
          <DockControlPanel
            v-if="dockControlPanelVisible"
            :sn="osdVisible.gateway_sn"
            :deviceInfo="deviceInfo"
            @close-control-panel="onCloseControlPanel"
          >
          </DockControlPanel>
        </div>
      </div>
      <!--  飞机-->
      <div class="flex-display">
        <div
          class="flex-column flex-align-stretch flex-justify-center"
          style="width: 60px; background: #2d2d2d"
        >
          <a-tooltip :title="osdVisible.model">
            <div
              style="width: 90%"
              class="flex-column flex-align-center flex-justify-center"
            >
              <span><a-image :src="M30" :preview="false" /></span>
              <span>M30</span>
            </div>
          </a-tooltip>
        </div>
        <div class="osd flex-1">
          <a-row>
            <a-col
              span="16"
              :style="
                !deviceInfo.device ||
                deviceInfo.device?.mode_code === EModeCode.Disconnected
                  ? 'color: red; font-weight: 700;'
                  : 'color: rgb(25,190,107)'
              "
            >
              {{
                !deviceInfo.device
                  ? EModeCode[EModeCode.Disconnected]
                  : EModeCode[deviceInfo.device?.mode_code]
              }}</a-col
            >
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Upward Quality">
                <span
                  ><SignalFilled /><ArrowUpOutlined
                    style="font-size: 9px; vertical-align: top"
                /></span>
                <span class="ml10">{{
                  deviceInfo.dock.link_osd?.sdr?.up_quality
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Downward Quality">
                <span
                  ><SignalFilled /><ArrowDownOutlined
                    style="font-size: 9px; vertical-align: top"
                /></span>
                <span class="ml10">{{
                  deviceInfo.dock.link_osd?.sdr?.down_quality
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Drone Battery Level">
                <span><ThunderboltOutlined class="fz14" /></span>
                <span class="ml10">{{
                  deviceInfo.device &&
                  deviceInfo.device.battery.capacity_percent !== str
                    ? deviceInfo.device?.battery.capacity_percent + " %"
                    : str
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip>
                <template #title>
                  <p>total: {{ deviceInfo.device?.storage?.total }}</p>
                  <p>used: {{ deviceInfo.device?.storage?.used }}</p>
                </template>
                <span><FolderOpenOutlined /></span>
                <span class="ml10" v-if="deviceInfo.device?.storage?.total > 0">
                  <a-progress
                    type="circle"
                    :width="20"
                    :percent="
                      (deviceInfo.device?.storage?.used * 100) /
                      deviceInfo.device?.storage?.total
                    "
                    :strokeWidth="20"
                    :showInfo="false"
                    :strokeColor="
                      (deviceInfo.device?.storage?.used * 100) /
                        deviceInfo.device?.storage?.total >
                      80
                        ? 'red'
                        : '#00ee8b'
                    "
                  />
                </span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-tooltip title="RTK Fixed">
              <a-col
                span="6"
                class="flex-row flex-align-center flex-justify-start"
              >
                <span>Fixed</span>
                <span
                  class="ml10 circle"
                  :style="
                    deviceInfo.device?.position_state.is_fixed === 1
                      ? 'backgroud: rgb(25,190,107);'
                      : ' background: red;'
                  "
                ></span>
              </a-col>
            </a-tooltip>
            <a-col span="6">
              <a-tooltip title="GPS">
                <span>GPS</span>
                <span class="ml10">{{
                  deviceInfo.device
                    ? deviceInfo.device.position_state.gps_number
                    : str
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="RTK">
                <span><TrademarkOutlined class="fz14" /></span>
                <span class="ml10">{{
                  deviceInfo.device
                    ? deviceInfo.device.position_state.rtk_number
                    : str
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Flight Mode">
                <span><ControlOutlined class="fz16" /></span>
                <span class="ml10">{{
                  deviceInfo.device ? EGear[deviceInfo.device?.gear] : str
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Altitude above sea level">
                <span>ASL</span>
                <span class="ml10">{{
                  !deviceInfo.device || deviceInfo.device.height === str
                    ? str
                    : deviceInfo.device?.height.toFixed(2) + " m"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Altitude above takeoff level">
                <span>ALT</span>
                <span class="ml10">{{
                  !deviceInfo.device || deviceInfo.device.elevation === str
                    ? str
                    : deviceInfo.device?.elevation.toFixed(2) + " m"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Distance to Home Point">
                <span
                  style="
                    border: 1px solid;
                    border-radius: 50%;
                    width: 18px;
                    height: 18px;
                    line-height: 15px;
                    text-align: center;
                    display: block;
                    float: left;
                  "
                  >H</span
                >
                <span class="ml10">{{
                  !deviceInfo.device || deviceInfo.device.home_distance === str
                    ? str
                    : deviceInfo.device?.home_distance.toFixed(2) + " m"
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="6">
              <a-tooltip title="Horizontal Speed">
                <span>H.S</span>
                <span class="ml10">{{
                  !deviceInfo.device ||
                  deviceInfo.device?.horizontal_speed === str
                    ? str
                    : deviceInfo.device?.horizontal_speed.toFixed(2) + " m/s"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Vertical Speed">
                <span>V.S</span>
                <span class="ml10">{{
                  !deviceInfo.device || deviceInfo.device.vertical_speed === str
                    ? str
                    : deviceInfo.device?.vertical_speed.toFixed(2) + " m/s"
                }}</span>
              </a-tooltip>
            </a-col>
            <a-col span="6">
              <a-tooltip title="Wind Speed">
                <span>W.S</span>
                <span class="ml10">{{
                  !deviceInfo.device || deviceInfo.device.wind_speed === str
                    ? str
                    : (deviceInfo.device?.wind_speed / 10).toFixed(2) + " m/s"
                }}</span>
              </a-tooltip>
            </a-col>
          </a-row>
        </div>
      </div>
      <div
        class="battery-slide"
        v-if="
          deviceInfo.device &&
          deviceInfo.device.battery.remain_flight_time !== 0
        "
        style="border: 1px solid red"
      >
        <div style="background: #535759" class="width-100"></div>
        <div
          class="capacity-percent"
          :style="{ width: deviceInfo.device.battery.capacity_percent + '%' }"
        ></div>
        <div
          class="return-home"
          :style="{ width: deviceInfo.device.battery.return_home_power + '%' }"
        ></div>
        <div
          class="landing"
          :style="{ width: deviceInfo.device.battery.landing_power + '%' }"
        ></div>
        <div
          class="white-point"
          :style="{ left: deviceInfo.device.battery.landing_power + '%' }"
        ></div>
        <div
          class="battery"
          :style="{ left: deviceInfo.device.battery.capacity_percent + '%' }"
        >
          {{ Math.floor(deviceInfo.device.battery.remain_flight_time / 60) }}:
          {{ 10 > deviceInfo.device.battery.remain_flight_time % 60 ? "0" : ""
          }}{{ deviceInfo.device.battery.remain_flight_time % 60 }}
        </div>
      </div>
      <!-- 飞行指令 -->
      <DroneControlPanel
        :sn="osdVisible.gateway_sn"
        :deviceInfo="deviceInfo"
        :payloads="osdVisible.payloads"
      ></DroneControlPanel>
    </div>
    <!-- liveview -->
    <div class="liveview" v-if="livestreamOthersVisible" v-drag-window>
      <div style="height: 40px; width: 100%" class="drag-title"></div>
      <a
        style="
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 16px;
          color: white;
        "
        @click="closeLivestreamOthers"
        ><CloseOutlined
      /></a>
      <LivestreamOthers />
    </div>
    <div class="liveview" v-if="livestreamAgoraVisible" v-drag-window>
      <div style="height: 40px; width: 100%" class="drag-title"></div>
      <a
        style="
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 16px;
          color: white;
        "
        @click="closeLivestreamAgora"
        ><CloseOutlined
      /></a>
      <LivestreamAgora />
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
} from 'vue'

import {
  generateLineContent,
  generatePointContent,
  generatePolyContent,
} from '../utils/map-layer-utils'
import { postElementsReq } from '/@/api/layer'
import { MapDoodleType, MapElementEnum } from '/@/constants/map'
import { useGMapManage } from '/@/hooks/use-g-map'
import { useGMapCover } from '/@/hooks/use-g-map-cover'
import { useMouseTool } from '/@/hooks/use-mouse-tool'
import { getApp, getRoot } from '/@/root'
import { useMyStore } from '/@/store'
import { GeojsonCoordinate } from '/@/types/map'
import { MapDoodleEnum } from '/@/types/map-enum'
import { PostElementsBody } from '/@/types/mapLayer'
import { uuidv4 } from '/@/utils/uuid'
import { gcj02towgs84, wgs84togcj02 } from '/@/vendors/coordtransform'
import { deviceTsaUpdate } from '/@/hooks/use-g-map-tsa'
import {
  DeviceOsd,
  DeviceStatus,
  DockOsd,
  EGear,
  EModeCode,
  GatewayOsd,
  EDockModeCode,
  NetworkStateQualityEnum,
  NetworkStateTypeEnum,
  RainfallEnum,
  DroneInDockEnum,
} from '/@/types/device'
import pin from '/assets/icons/pin-2d8cf0.svg'
import M30 from '/assets/icons/m30.png'
import {
  BorderOutlined,
  LineOutlined,
  CloseOutlined,
  ControlOutlined,
  TrademarkOutlined,
  ArrowDownOutlined,
  ThunderboltOutlined,
  SignalFilled,
  GlobalOutlined,
  HistoryOutlined,
  CloudUploadOutlined,
  RocketOutlined,
  FieldTimeOutlined,
  CloudOutlined,
  CloudFilled,
  FolderOpenOutlined,
  RobotFilled,
  ArrowUpOutlined,
  CarryOutOutlined,
} from '@ant-design/icons-vue'
import { EDeviceTypeName } from '../types'
import DockControlPanel from './g-map/DockControlPanel.vue'
import { useDockControl } from './g-map/use-dock-control'
import DroneControlPanel from './g-map/DroneControlPanel.vue'
import { useConnectMqtt } from './g-map/use-connect-mqtt'
import LivestreamOthers from './livestream-others.vue'
import LivestreamAgora from './livestream-agora.vue'
import FlightAreaActionIcon from './flight-area/FlightAreaActionIcon.vue'
import { EFlightAreaType } from '../types/flight-area'
import { useFlightArea } from './flight-area/use-flight-area'
import { useFlightAreaDroneLocationEvent } from './flight-area/use-flight-area-drone-location-event'
import { message } from 'ant-design-vue'
import { MapTypes } from '/@/constants/index'
import { Check, Plane, Locate } from 'lucide-vue-next'
import { useRoute } from 'vue-router'
import { useAreaRouteState } from '/@/piniastore/areaRouteState.js'
import { usePolygonState } from '/@/piniastore/polygonState.js'
import { mapEventBus } from '../utils/mapEventBus'
import { useSetWaypointsState } from '../piniastore/setWaypointsState'
import { useWaylineState } from '/@/piniastore/waylineState'
import { useflightPlanState } from '/@/piniastore/flightPlanState'
import { mapState } from 'pinia'
import { useMapState } from '../piniastore/mapState'
import { useTelemetryState } from '../piniastore/telemetryState'
import FlightManager from '/@/lib/flight-plan-manager.js'

export default defineComponent({
  components: {
    BorderOutlined,
    LineOutlined,
    CloseOutlined,
    ControlOutlined,
    TrademarkOutlined,
    ThunderboltOutlined,
    SignalFilled,
    GlobalOutlined,
    HistoryOutlined,
    CloudUploadOutlined,
    FieldTimeOutlined,
    CloudOutlined,
    CloudFilled,
    FolderOpenOutlined,
    RobotFilled,
    ArrowUpOutlined,
    ArrowDownOutlined,
    DockControlPanel,
    DroneControlPanel,
    CarryOutOutlined,
    RocketOutlined,
    LivestreamOthers,
    LivestreamAgora,
    FlightAreaActionIcon,
  },
  name: 'GMap',
  props: {},
  setup () {
    const router = useRoute()
    const showAreaConfig = useAreaRouteState()
    const polygonState = usePolygonState()
    const setWaypointState = useSetWaypointsState()
    const useMouseToolHook = useMouseTool()
    const useGMapManageHook = useGMapManage()
    const flightManager = new FlightManager()
    // let deviceTsaUpdateHook: any = null
    const root = getRoot()
    const route = useRoute()
    const waylineState = useWaylineState()
    const flightPlanState = useflightPlanState()
    const state = useMapState()
    // const root = getRoot()
    const map = root.$map
    const leaflet = root.$leaflet
    // Add a watcher for route changes to handle grid planning data
    // In GMap.vue setup() function
    watch(
      () => route.path,
      (newPath, oldPath) => {
        console.log('Route changed from', oldPath, 'to', newPath)

        // Always clear map when leaving any planning page
        if (oldPath === '/area-route' || oldPath === '/set-waypoints' || newPath === '/wayline') {
          console.log('🚪 Leaving planning page, clearing map')
          useGMapManageHook.clearAllMapLayers()
        }

        // Handle new route navigation
        if (newPath === '/area-route') {
          setTimeout(() => {
            handleAreaRouteNavigation()
          }, 300)
        } else if (newPath === '/set-waypoints') {
          useGMapManageHook.enableWaypointMode()
        } else {
          useGMapManageHook.disableWaypointMode()
        }
        // ✅ ADD THIS: Clear map when going to wayline
        if (newPath === '/wayline') {
          console.log('📍 Navigating to wayline, clearing map')
          useGMapManageHook.clearAllMapLayersonWayline()
        }
      },
      { immediate: true }
    )

    const telemetryData = useTelemetryState()
    // Add this watcher in GMap.vue setup()
    // Add this watcher in GMap.vue setup()
    console.log('telemetryData', telemetryData?.telemetryData)
    watch(
      () => telemetryData?.telemetryData,
      (data) => {
        console.log('telemetrydata in watch:', data)
      },
      { immediate: true }
    )
    const areaState = useAreaRouteState()
    function handleAreaRouteNavigation () {
      console.log('🚀 Handling area route navigation')

      // Check if we're in edit mode and have wayline data
      if (waylineState.isEditMode && waylineState.editWaylineData) {
        console.log('✏️ Edit mode detected, rendering existing grid planning data')

        // Clear any existing map content first
        // useGMapManageHook.clearAllMapLayers()

        // Show area config
        areaState.setIsShow(true)

        // Render the mission data (this will add polygon to drawnItems)
        // Use a small delay to ensure map is ready
        setTimeout(() => {
          renderMissionData(waylineState.editWaylineData)

          // Enable edit controls
          setTimeout(() => {
            if (state.drawControl) {
              const editToolbar = state.drawControl._toolbars?.edit
              if (editToolbar) {
                editToolbar.enable()
                console.log('✅ Edit controls enabled in handleAreaRouteNavigation')
              }
            }
          }, 300)
        }, 100)

        // Also set the flight plan in the store
        if (waylineState.editWaylineData.wpml?.Document?.Folder?.Placemark) {
          const flightPlan = convertWaylineToFlightPlan(waylineState.editWaylineData)
          flightPlanState.setFlightPlan(flightPlan)
        }
      } else {
        console.log('📝 Not in edit mode, clearing map for new planning')
        // Clear map for new planning

        areaState.setIsShow(false)
        polygonState.setIsFormed(false)
        polygonState.setGeoJsonPolygon(null)
        polygonState.polygonLayer = null
        waylineState.setEditWaylineData(null)
        state.flightLayer.clearLayers()
        state.map.removeLayer(state.flightLayer)
      }
      // state.flightLayer.clearLayers()
      // state.map.removeLayer(state.flightLayer)
    }

    function renderMissionData (missionData) {
      console.log('📊 renderMissionData called with:', missionData)
      if (!missionData) return

      const map = (root as any).$map
      const leaflet = (root as any).$leaflet

      if (!map || !leaflet) {
        console.warn('⚠️ Map or Leaflet not available')
        return
      }

      try {
        // Clear existing flight layer
        if (window.currentFlightLayer) {
          map.removeLayer(window.currentFlightLayer)
        }

        window.currentFlightLayer = new leaflet.FeatureGroup()
        const bounds = []

        // Check if this is grid planning (has polygon)
        const hasPolygon = missionData.kml?.Document?.Folder?.Placemark?.Polygon

        if (hasPolygon) {
          console.log('🔷 Rendering grid planning polygon')

          const polygonState = usePolygonState()
          const kmlPolygonCoords = missionData.kml.Document.Folder.Placemark.Polygon.outerBoundaryIs.LinearRing.coordinates.coordinates

          const coordinates = kmlPolygonCoords.split(' ').map(coordStr => {
            const [lon, lat, alt] = coordStr.split(',').map(Number)
            return [lon, lat]
          }).filter(coord => !isNaN(coord[0]) && !isNaN(coord[1]))

          // Create GeoJSON polygon
          const geoJsonPolygon = {
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: [coordinates]
            },
            properties: {}
          }

          console.log('geoJsonPolygon', geoJsonPolygon)

          polygonState.setGeoJsonPolygon(geoJsonPolygon)
          polygonState.setIsFormed(true)

          // Convert to Leaflet coordinates [lat, lng]
          const polygonPoints = coordinates.map(coord => [coord[1], coord[0]])

          if (polygonPoints.length >= 3) {
            // Create polygon
            const polygon = leaflet.polygon(polygonPoints, {
              color: 'blue',
              weight: 3,
              fillColor: 'blue',
              fillOpacity: 0.1,
              opacity: 0.8
            }).addTo(map)
            console.log('polygon', polygon)
            polygonState.polygonLayer = polygon
            state.drawnItems.addLayer(polygon)
            // ✅ CRITICAL: Add to drawnItems (makes it editable)

            // const drawnItems = new leaflet.FeatureGroup()
            // map.addLayer(drawnItems)
            // drawnItems.addLayer(polygon)
            // state.drawnItems.addLayer(polygon)
            // console.log('✅ Polygon added to drawnItems,total layers:', state.drawnItems.getLayers().length)

            // // Also add to display layer
            // polygon.addTo(window.currentFlightLayer)

            // // Store reference
            // polygonState.polygonLayer = polygon

            // // Add to bounds
            // polygonPoints.forEach(point => {
            //   bounds.push(leaflet.latLng(point[0], point[1]))
            // })

            // console.log('✅ Polygon rendered with', polygonPoints.length, 'points')
          }

          // Render waypoints (existing code)
          const placemarks = missionData.wpml?.Document?.Folder?.Placemark || []
          const placemarksArray = Array.isArray(placemarks) ? placemarks : [placemarks]

          if (placemarksArray.length > 0) {
            const waypoints = []

            placemarksArray.forEach((pm, i) => {
              if (pm.Point?.coordinates?.coordinates) {
                const [lon, lat] = pm.Point.coordinates.coordinates.split(',').map(Number)
                if (!isNaN(lat) && !isNaN(lon)) {
                  waypoints.push([lat, lon])

                  const isFirst = i === 0
                  const isLast = i === placemarksArray.length - 1
                  const label = isFirst ? 'S' : (isLast ? 'E' : (i + 1).toString())
                  const color = isFirst ? 'green' : (isLast ? 'red' : '#2D8CF0')

                  const marker = leaflet.marker([lat, lon], {
                    icon: leaflet.divIcon({
                      className: 'waypoint-marker',
                      html: `<div style="background:${color};color:white;border-radius:50%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:bold;">${label}</div>`,
                      iconSize: [24, 24],
                      iconAnchor: [12, 12],
                    })
                  }).addTo(window.currentFlightLayer)

                  marker.bindTooltip(
                `Waypoint ${i}<br>Lat: ${lat.toFixed(6)}<br>Lng: ${lon.toFixed(6)}`,
                { permanent: false }
                  )

                  bounds.push(leaflet.latLng(lat, lon))
                }
              }
            })

            if (waypoints.length > 1) {
              leaflet.polyline(waypoints, {
                color: '#FF5733',
                weight: 3,
                opacity: 0.8
              }).addTo(window.currentFlightLayer)
            }

            console.log('✅ Waypoints rendered:', waypoints.length)
          }
        }

        // Add to map and fit bounds
        window.currentFlightLayer.addTo(map)
        if (bounds.length > 0) {
          map.fitBounds(leaflet.latLngBounds(bounds), { padding: [50, 50], maxZoom: 18 })
        }

        console.log('✅ Mission data rendered successfully')
      } catch (error) {
        console.error('❌ Error rendering mission data:', error)
      }
    }

    function convertWaylineToFlightPlan (waylineData) {
      const flightPlan = {
        flightPlan: {
          polygon: null,
          waypoints: [],
          statistics: {
            totalDistance: 0,
            totalTime: 0
          }
        }
      }

      try {
        // Extract polygon from KML
        if (waylineData.kml?.Document?.Folder?.Placemark?.Polygon) {
          const kmlPolygonCoords = waylineData.kml.Document.Folder.Placemark.Polygon.outerBoundaryIs.LinearRing.coordinates.coordinates
          const coordinates = kmlPolygonCoords.split(' ').map(coordStr => {
            const [lon, lat, alt] = coordStr.split(',').map(Number)
            return [lon, lat]
          }).filter(coord => !isNaN(coord[0]) && !isNaN(coord[1]))

          flightPlan.flightPlan.polygon = {
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: [coordinates]
            },
            properties: {}
          }
        }

        // Extract waypoints from WPML
        const placemarks = waylineData.wpml?.Document?.Folder?.Placemark || []
        const placemarksArray = Array.isArray(placemarks) ? placemarks : [placemarks]

        flightPlan.flightPlan.waypoints = placemarksArray.map((pm, index) => {
          if (pm.Point?.coordinates?.coordinates) {
            const [lon, lat] = pm.Point.coordinates.coordinates.split(',').map(Number)
            return {
              index: index,
              position: {
                geometry: {
                  type: 'Point',
                  coordinates: [lon, lat]
                }
              },
              altitude: parseFloat(pm.executeHeight?.executeHeight) || 0
            }
          }
          return null
        }).filter(Boolean)

        // Calculate statistics
        if (flightPlan.flightPlan.waypoints.length > 1) {
          let totalDistance = 0
          for (let i = 1; i < flightPlan.flightPlan.waypoints.length; i++) {
            const prev = flightPlan.flightPlan.waypoints[i - 1].position.geometry.coordinates
            const curr = flightPlan.flightPlan.waypoints[i].position.geometry.coordinates
            // Simple distance calculation (you might want to use a more accurate method)
            const distance = Math.sqrt(
              Math.pow(curr[0] - prev[0], 2) + Math.pow(curr[1] - prev[1], 2)
            ) * 111000 // Approximate conversion to meters
            totalDistance += distance
          }
          flightPlan.flightPlan.statistics.totalDistance = totalDistance
        }
      } catch (error) {
        console.error('Error converting wayline to flight plan:', error)
      }

      return flightPlan
    }

    watch(
      () => waylineState.isEditMode,
      (newVal) => {
        console.log('Edit mode changed:', newVal)
        if (newVal && route.path === '/area-route') {
          // If we're already on area-route and edit mode is enabled, render the data
          setTimeout(() => {
            handleAreaRouteNavigation()
          }, 300)
        }
      }
    )

    window.currentFlightLayer = null

    // 1. Make deviceTsaUpdateHook reactive and initialize earlier
    let deviceTsaUpdateHook: any = null

    // Add this to your GMap.vue setup() function to replace the existing functions

    // COMPLETE REPLACEMENT for loadAndPlotAnnotations function in GMap.vue
    // Find and replace the entire function

    async function loadAndPlotAnnotations () {
      try {
        const useGMapCoverHook = useGMapCover()
        const layers = store.state.Layers
        const map = (root as any).$map
        const leaflet = (root as any).$leaflet

        if (!map || !leaflet) {
          console.warn('Map or Leaflet not ready yet')
          return
        }

        console.log('📍 Loading annotations with labels...')

        // Initialize labels storage
        if (!window.annotationLabels) {
          window.annotationLabels = {}
        }

        // Iterate through all layers
        layers.forEach((layer) => {
          // Skip if no elements
          if (!layer.elements || layer.elements.length === 0) {
            return
          }

          // Process each element in the layer
          layer.elements.forEach((element) => {
            try {
              // Validate element structure
              if (
                !element.resource ||
            !element.resource.content ||
            !element.resource.content.geometry
              ) {
                console.warn('Invalid element structure:', element)
                return
              }

              const coords = element.resource.content.geometry.coordinates
              if (!coords || coords.length === 0) {
                console.warn('Element has no coordinates:', element)
                return
              }

              // Create a deep copy to avoid modifying original
              const elementCopy = JSON.parse(JSON.stringify(element))

              // Convert WGS84 to GCJ02 for display
              updateCoordinates('wgs84-gcj02', elementCopy)

              const elementData = {
                id: element.id,
                name: element.name,
              }

              const color = element.resource.content.properties?.color || '#2D8CF0'

              // Render based on element type
              switch (element.resource.type) {
                case 0: // PIN - Point
                case MapElementEnum.PIN: {
                  const convertedCoords = elementCopy.resource.content.geometry.coordinates
                  if (convertedCoords && convertedCoords.length >= 2) {
                    const marker = useGMapCoverHook.init2DPin(
                      element.name,
                      [convertedCoords[0], convertedCoords[1]],
                      color,
                      elementData
                    )

                    // Add permanent label to marker
                    if (marker) {
                      console.log('✅ Adding label to pin:', element.name)

                      // Create a custom tooltip that's always visible
                      const tooltip = leaflet.tooltip({
                        permanent: true,
                        direction: 'top',
                        offset: [0, -25],
                        className: 'pin-annotation-label',
                        opacity: 1
                      })

                      tooltip.setContent(element.name)
                      marker.bindTooltip(tooltip)

                      // Store marker reference
                      if (!store.state.coverMap[element.id]) {
                        store.state.coverMap[element.id] = []
                      }
                    }
                  }
                  break
                }

                case 1: // LINE - LineString
                case MapElementEnum.LINE: {
                  const convertedCoords = elementCopy.resource.content.geometry.coordinates
                  if (convertedCoords && convertedCoords.length >= 2) {
                    const line = useGMapCoverHook.initPolyline(
                      element.name,
                      convertedCoords,
                      color,
                      elementData
                    )

                    // Add label at the middle of the line
                    if (line && convertedCoords.length > 0) {
                      console.log('✅ Adding label to line:', element.name)

                      const midIndex = Math.floor(convertedCoords.length / 2)
                      const midPoint = convertedCoords[midIndex]

                      const labelMarker = leaflet.marker([midPoint[1], midPoint[0]], {
                        icon: leaflet.divIcon({
                          className: 'line-polygon-label',
                          html: `<div class="annotation-label-box">${element.name}</div>`,
                          iconSize: [0, 0],
                          iconAnchor: [0, 0]
                        }),
                        interactive: false
                      })

                      labelMarker.addTo(map)
                      window.annotationLabels[element.id] = labelMarker

                      // Store line reference
                      if (!store.state.coverMap[element.id]) {
                        store.state.coverMap[element.id] = []
                      }
                    }
                  }
                  break
                }

                case 2: // POLY - Polygon
                case MapElementEnum.POLY: {
                  const convertedCoords = elementCopy.resource.content.geometry.coordinates
                  if (convertedCoords && convertedCoords[0] && convertedCoords[0].length >= 3) {
                    const polygon = useGMapCoverHook.initPolygon(
                      element.name,
                      convertedCoords,
                      color,
                      elementData
                    )

                    // Add label at center of polygon
                    if (polygon && convertedCoords[0].length > 0) {
                      console.log('✅ Adding label to polygon:', element.name)

                      const bounds = leaflet.latLngBounds(
                        convertedCoords[0].map(coord => [coord[1], coord[0]])
                      )
                      const center = bounds.getCenter()

                      const labelMarker = leaflet.marker([center.lat, center.lng], {
                        icon: leaflet.divIcon({
                          className: 'line-polygon-label',
                          html: `<div class="annotation-label-box">${element.name}</div>`,
                          iconSize: [0, 0],
                          iconAnchor: [0, 0]
                        }),
                        interactive: false
                      })

                      labelMarker.addTo(map)
                      window.annotationLabels[element.id] = labelMarker

                      // Store polygon reference
                      if (!store.state.coverMap[element.id]) {
                        store.state.coverMap[element.id] = []
                      }
                    }
                  }
                  break
                }

                default:
                  console.warn('Unknown element type:', element.resource?.type, element)
              }
            } catch (elementError) {
              console.error(`Error plotting element ${element.name}:`, elementError, element)
            }
          })
        })

        console.log('✅ All annotations plotted with labels')
      } catch (error) {
        console.error('❌ Error plotting annotations:', error)
        message.error('Failed to load annotations')
      }
    }

    // COMPLETE REPLACEMENT for navigateMapToAnnotation function
    function navigateMapToAnnotation (data) {
      const { element, center, bounds, zoom } = data

      const map = (root as any).$map
      const leaflet = (root as any).$leaflet

      if (!map || !leaflet) {
        console.warn('⚠️ Map or Leaflet not available')
        return
      }

      console.log('🗺️ Navigating to:', element.name, 'Type:', element.resource?.type)

      try {
        if (bounds && bounds.length > 1) {
          // For lines and polygons, fit bounds with padding
          console.log('📐 Fitting bounds for line/polygon')
          const latLngBounds = leaflet.latLngBounds(bounds)

          map.flyToBounds(latLngBounds, {
            padding: [80, 80],
            maxZoom: zoom || 16,
            animate: true,
            duration: 1.5
          })
        } else if (center) {
          // For points, fly to center with zoom
          console.log('📍 Flying to point:', center, 'zoom:', zoom)

          map.flyTo(center, zoom || 18, {
            animate: true,
            duration: 1.5
          })
        }

        // Highlight after navigation
        setTimeout(() => {
          highlightAnnotation(element.id)
        }, 1600)
      } catch (error) {
        console.error('❌ Error navigating map:', error)
      }
    }

    // COMPLETE REPLACEMENT for highlightAnnotation function
    function highlightAnnotation (elementId) {
      const map = (root as any).$map
      const leaflet = (root as any).$leaflet

      if (!map || !leaflet) return

      console.log('✨ Highlighting annotation:', elementId)

      // Find the layer/marker for this element
      const coverMap = store.state.coverMap

      if (coverMap && coverMap[elementId]) {
        const layers = coverMap[elementId]

        layers.forEach(layer => {
          if (layer.getLatLng) {
            // For markers (pins)
            const latLng = layer.getLatLng()
            console.log('💫 Creating pulse effect for pin')

            const pulseCircle = leaflet.circle(latLng, {
              radius: 30,
              color: '#ff0000',
              fillColor: '#ff0000',
              fillOpacity: 0.4,
              weight: 3
            }).addTo(map)

            // Animate the pulse
            let radius = 30
            const pulseInterval = setInterval(() => {
              radius += 15
              const opacity = Math.max(0, 0.4 - (radius - 30) / 300)

              pulseCircle.setRadius(radius)
              pulseCircle.setStyle({
                fillOpacity: opacity,
                opacity: opacity
              })

              if (radius > 200) {
                clearInterval(pulseInterval)
                map.removeLayer(pulseCircle)
              }
            }, 60)
          } else if (layer.setStyle) {
            // For polylines and polygons
            console.log('💫 Creating flash effect for line/polygon')

            const originalStyle = {
              color: layer.options.color,
              weight: layer.options.weight,
              fillOpacity: layer.options.fillOpacity
            }

            // Flash animation sequence
            const flashSequence = [
              { delay: 0, color: '#ff0000', weight: originalStyle.weight + 3 },
              { delay: 300, color: originalStyle.color, weight: originalStyle.weight },
              { delay: 600, color: '#ff0000', weight: originalStyle.weight + 3 },
              { delay: 900, color: originalStyle.color, weight: originalStyle.weight },
              { delay: 1200, color: '#ff0000', weight: originalStyle.weight + 3 },
              { delay: 1500, color: originalStyle.color, weight: originalStyle.weight }
            ]

            flashSequence.forEach(step => {
              setTimeout(() => {
                if (map.hasLayer(layer)) {
                  layer.setStyle({
                    color: step.color,
                    weight: step.weight
                  })
                }
              }, step.delay)
            })
          }
        })
      } else {
        console.warn('⚠️ No layer found for element:', elementId)
      }
    }

    const setupAnnotationNavigation = () => {
      // Listen for navigation events
      mapEventBus.on('navigateToAnnotation', (data) => {
        navigateMapToAnnotation(data)
      })

      // Listen for highlight events
      mapEventBus.on('highlightAnnotation', (elementId) => {
        highlightAnnotation(elementId)
      })
    }

    // In GMap.vue setup()

    // function navigateMapToAnnotation (data) {
    //   const { element, center, bounds, zoom } = data

    //   if (!useGMapManageHook.isMapReady()) {
    //     console.warn('Map not ready for navigation')
    //     return
    //   }

    //   const map = (root as any).$map
    //   const leaflet = (root as any).$leaflet // Get Leaflet from global properties

    //   if (!map || !leaflet) {
    //     console.warn('Map or Leaflet instance not available')
    //     return
    //   }

    //   try {
    //     if (bounds && bounds.length > 1) {
    //       // For lines and polygons, fit bounds
    //       const latLngBounds = leaflet.latLngBounds(bounds) // Use leaflet from hook
    //       map.fitBounds(latLngBounds, {
    //         padding: [20, 20],
    //         maxZoom: zoom || 14,
    //       })
    //     } else if (center) {
    //       // For points, center and zoom
    //       map.setView(center, zoom || 16)
    //     }
    //   } catch (error) {
    //     console.error('Error navigating map to annotation:', error)
    //   }
    // }

    // function highlightAnnotation (elementId) {
    //   const useGMapCoverHook = useGMapCover()

    //   // Remove any existing highlights
    //   const existingHighlights = document.querySelectorAll(
    //     '.annotation-highlight'
    //   )
    //   existingHighlights.forEach((el) =>
    //     el.classList.remove('annotation-highlight')
    //   )

    //   // Find and highlight the specific annotation
    //   const element = findAnnotationElement(elementId)
    //   if (element) {
    //     element.classList.add('annotation-highlight')

    //     // Remove highlight after 3 seconds
    //     setTimeout(() => {
    //       element.classList.remove('annotation-highlight')
    //     }, 3000)
    //   }
    // }

    function findAnnotationElement (elementId) {
      // This depends on how your useGMapCoverHook stores elements
      // You might need to modify useGMapCoverHook to expose element references
      const coverMap = store.state.coverMap
      if (coverMap && coverMap[elementId]) {
        return coverMap[elementId][0]?.getElement?.()
      }
      return null
    }

    // Handle map ready event
    const onMapReady = ({ map, leaflet }) => {
      deviceTsaUpdateHook = deviceTsaUpdate()
      restoreExistingDeviceMarkers()
    }

    // Handle map destroyed event
    const onMapDestroyed = () => {
      if (
        deviceTsaUpdateHook &&
        typeof deviceTsaUpdateHook.cleanup === 'function'
      ) {
        deviceTsaUpdateHook.cleanup()
      }
      deviceTsaUpdateHook = null
    }

    const restoreExistingDeviceMarkers = () => {
      if (!deviceTsaUpdateHook) return

      const deviceState = store.state.deviceState

      try {
        // Gateways
        if (deviceState.gatewayInfo) {
          Object.entries(deviceState.gatewayInfo).forEach(([sn, gateway]) => {
            if (gateway.longitude && gateway.latitude) {
              deviceTsaUpdateHook.initMarker(
                EDeviceTypeName.Gateway,
                `Gateway-${sn}`,
                sn,
                gateway.longitude,
                gateway.latitude
              )
            }
          })
        }

        // Aircraft
        if (deviceState.deviceInfo) {
          Object.entries(deviceState.deviceInfo).forEach(([sn, device]) => {
            if (device.longitude && device.latitude) {
              deviceTsaUpdateHook.initMarker(
                EDeviceTypeName.Aircraft,
                `Aircraft-${sn}`,
                sn,
                device.longitude,
                device.latitude
              )
            }
          })
        }

        // Docks
        if (deviceState.dockInfo) {
          Object.entries(deviceState.dockInfo).forEach(([sn, dock]) => {
            if (dock.basic_osd?.longitude && dock.basic_osd?.latitude) {
              deviceTsaUpdateHook.initMarker(
                EDeviceTypeName.Dock,
                `Dock-${sn}`,
                sn,
                dock.basic_osd.longitude,
                dock.basic_osd.latitude
              )
            }
          })
        }
      } catch (error) {
        console.error('Error restoring device markers:', error)
      }
    }

    const mouseMode = ref(false)
    const currentMapType = ref(' Select Layers')
    const store = useMyStore()
    // const state = reactive({
    //   currentType: '',
    //   coverIndex: 0,
    //   isFlightArea: false,
    //   enableDrawingMode: false,
    //   drawnItems: null as any,
    // })
    const str: string = '--'
    const deviceInfo = reactive({
      gateway: {
        capacity_percent: str,
        transmission_signal_quality: str,
      } as GatewayOsd,
      dock: {} as DockOsd,
      device: {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: str,
        vertical_speed: str,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
          gps_number: str,
          is_fixed: 0,
          rtk_number: str,
        },
        battery: {
          capacity_percent: str,
          landing_power: str,
          remain_flight_time: 0,
          return_home_power: str,
        },
        latitude: 0,
        longitude: 0,
      } as DeviceOsd,
    })
    const shareId = computed(() => {
      return store.state.layerBaseInfo.share
    })
    // const deviceInfoo = computed(() => store.state.deviceState.deviceInfo)
    // console.log('deviceInfo:', deviceInfoo)
    const defaultId = computed(() => {
      return store.state.layerBaseInfo.default
    })
    const drawVisible = computed(() => {
      return store.state.drawVisible
    })
    const livestreamOthersVisible = computed(() => {
      return store.state.livestreamOthersVisible
    })
    const livestreamAgoraVisible = computed(() => {
      return store.state.livestreamAgoraVisible
    })
    const osdVisible = computed(() => {
      return store.state.osdVisible
    })
    const qualityStyle = computed(() => {
      if (
        deviceInfo.dock.basic_osd?.network_state?.type ===
          NetworkStateTypeEnum.ETHERNET ||
        (deviceInfo.dock.basic_osd?.network_state?.quality || 0) >
          NetworkStateQualityEnum.FAIR
      ) {
        return 'color: #00ee8b'
      }
      if (
        (deviceInfo.dock.basic_osd?.network_state?.quality || 0) ===
        NetworkStateQualityEnum.FAIR
      ) {
        return 'color: yellow'
      }
      return 'color: red'
    })
    watch(
      () => store?.state?.deviceStatusEvent,
      (data) => {
        if (Object.keys(data.deviceOnline).length !== 0) {
          if (deviceTsaUpdateHook.value) {
            deviceTsaUpdateHook.value.initMarker(
              data.deviceOnline.domain,
              data.deviceOnline.device_callsign,
              data.deviceOnline.sn
            )
          }
          store.state.deviceStatusEvent.deviceOnline = {} as DeviceStatus
        }
        if (Object.keys(data.deviceOffline).length !== 0) {
          // Note: removeMarker functionality simplified - markers remain on map
          if (
            data.deviceOffline.sn === osdVisible.value.sn ||
            (osdVisible.value.is_dock &&
              data.deviceOffline.sn === osdVisible.value.gateway_sn)
          ) {
            osdVisible.value.visible = false
            store.commit('SET_OSD_VISIBLE_INFO', osdVisible)
          }
          store.state.deviceStatusEvent.deviceOffline = {}
        }
      },
      {
        deep: true,
      }
    )

    watch(
      () => store.state.deviceState,
      (data) => {
        if (!deviceTsaUpdateHook) {
          console.warn('deviceTsaUpdateHook not initialized yet')
          return
        }

        // ... rest of your existing watch logic remains the same
        // Handle real-time updates
        if (
          data.currentType === EDeviceTypeName.Gateway &&
          data.gatewayInfo[data.currentSn]
        ) {
          const gateway = data.gatewayInfo[data.currentSn]
          if (gateway.longitude && gateway.latitude) {
            deviceTsaUpdateHook.initMarker(
              EDeviceTypeName.Gateway,
              `Gateway-${data.currentSn}`,
              data.currentSn,
              gateway.longitude,
              gateway.latitude
            )
            deviceTsaUpdateHook.moveTo(data.currentSn, gateway.longitude, gateway.latitude)
          }
        }
        if (
          data.currentType === EDeviceTypeName.Aircraft &&
          data.deviceInfo[data.currentSn]
        ) {
          const aircraft = data.deviceInfo[data.currentSn]
          if (aircraft.longitude && aircraft.latitude) {
            deviceTsaUpdateHook.initMarker(
              EDeviceTypeName.Aircraft,
              `Aircraft-${data.currentSn}`,
              data.currentSn,
              aircraft.longitude,
              aircraft.latitude
            )
            deviceTsaUpdateHook.moveTo(data.currentSn, aircraft.longitude, aircraft.latitude)
          }
        }
        if (
          data.currentType === EDeviceTypeName.Dock &&
          data.dockInfo[data.currentSn]
        ) {
          const dockLng = data.dockInfo[data.currentSn].basic_osd?.longitude
          const dockLat = data.dockInfo[data.currentSn].basic_osd?.latitude
          if (dockLng && dockLat) {
            deviceTsaUpdateHook.initMarker(
              EDeviceTypeName.Dock,
              EDeviceTypeName[EDeviceTypeName.Dock],
              data.currentSn,
              dockLng,
              dockLat
            )
            deviceTsaUpdateHook.moveTo(data.currentSn, dockLng, dockLat)
          }
          if (
            osdVisible.value.visible &&
            osdVisible.value.is_dock &&
            osdVisible.value.gateway_sn !== ''
          ) {
            deviceInfo.dock = data.dockInfo[osdVisible.value.gateway_sn]
            deviceInfo.device =
              data.deviceInfo[
                deviceInfo.dock.basic_osd.sub_device?.device_sn ??
                  osdVisible.value.sn
              ]
          }
        }
        // ... continue with existing aircraft and dock logic
      },
      {
        deep: true,
      }
    )

    watch(
      () => store.state.wsEvent,
      (newData) => {
        const useGMapCoverHook = useGMapCover()
        const event = newData
        let exist = false
        if (Object.keys(event.mapElementCreat).length !== 0) {
          const ele = event.mapElementCreat
          store.state.Layers.forEach((layer) => {
            layer.elements.forEach((e) => {
              if (e.id === ele.id) {
                exist = true
              }
            })
          })
          if (exist === false) {
            setLayers({
              id: ele.id,
              name: ele.name,
              resource: ele.resource,
            })

            updateCoordinates('wgs84-gcj02', ele)
            const data = { id: ele.id, name: ele.name }
            if (MapElementEnum.PIN === ele.resource?.type) {
              useGMapCoverHook.init2DPin(
                ele.name,
                ele.resource.content.geometry.coordinates,
                ele.resource.content.properties.color,
                data
              )
            } else if (MapElementEnum.LINE === ele.resource?.type) {
              useGMapCoverHook.initPolyline(
                ele.name,
                ele.resource.content.geometry.coordinates,
                ele.resource.content.properties.color,
                data
              )
            } else if (MapElementEnum.POLY === ele.resource?.type) {
              useGMapCoverHook.initPolygon(
                ele.name,
                ele.resource.content.geometry.coordinates,
                ele.resource.content.properties.color,
                data
              )
            }
          }

          store.state.wsEvent.mapElementCreat = {}
        }
        if (Object.keys(event.mapElementUpdate).length !== 0) {
          store.state.wsEvent.mapElementUpdate = {}
        }
        if (Object.keys(event.mapElementDelete).length !== 0) {
          store.state.wsEvent.mapElementDelete = {}
        }
      },
      {
        deep: true,
      }
    )

    // In GMap setup()
    // const telemetryData = useTelemetryState()
    // const store = useMyStore()

    // Add a computed property to get the current device's telemetry data
    const currentDeviceTelemetry = computed(() => {
      if (!osdVisible.value.visible || !osdVisible.value.sn) {
        return null
      }

      const deviceSn = osdVisible.value.sn
      const telemetry = telemetryData.telemetryData

      console.log('🔍 Looking for device SN:', deviceSn)
      console.log('🔍 Available telemetry keys:', Object.keys(telemetry || {}))

      // Check if the current device's data exists in telemetry
      if (telemetry && telemetry[deviceSn]) {
        console.log('✅ Found telemetry data for device:', deviceSn)
        return telemetry[deviceSn]
      }

      console.log('❌ No telemetry data found for device:', deviceSn)
      return null
    })

    // Watch for telemetry data changes and update deviceInfo
    watch(() => telemetryData.telemetryData, (newTelemetry) => {
      console.log('📡 Telemetry data updated:', newTelemetry)

      if (osdVisible.value.visible && osdVisible.value.sn) {
        const deviceSn = osdVisible.value.sn
        const deviceTelemetry = newTelemetry?.[deviceSn]

        if (deviceTelemetry) {
          console.log('🔄 Updating deviceInfo with telemetry data for:', deviceSn)

          // Update deviceInfo with the new telemetry data
          Object.assign(deviceInfo.device, {
            // Flight status
            mode_code: deviceTelemetry.mode_code,
            gear: deviceTelemetry.gear,

            // Position data
            latitude: deviceTelemetry.latitude,
            longitude: deviceTelemetry.longitude,
            height: deviceTelemetry.height,
            elevation: deviceTelemetry.elevation,
            home_distance: deviceTelemetry.home_distance,

            // Movement data
            horizontal_speed: deviceTelemetry.horizontal_speed,
            vertical_speed: deviceTelemetry.vertical_speed,

            // Battery info
            battery: {
              capacity_percent: deviceTelemetry.battery?.capacity_percent,
              remain_flight_time: deviceTelemetry.battery?.remain_flight_time,
              return_home_power: deviceTelemetry.battery?.return_home_power,
              landing_power: deviceTelemetry.battery?.landing_power
            },

            // Position state
            position_state: {
              gps_number: deviceTelemetry.position_state?.gps_number,
              rtk_number: deviceTelemetry.position_state?.rtk_number,
              is_fixed: deviceTelemetry.position_state?.is_fixed
            },

            // Weather/environment
            wind_speed: deviceTelemetry.wind_speed,
            wind_direction: deviceTelemetry.wind_direction,

            // Storage
            storage: deviceTelemetry.storage,

            // Attitude
            attitude_head: deviceTelemetry.attitude_head,
            attitude_pitch: deviceTelemetry.attitude_pitch,
            attitude_roll: deviceTelemetry.attitude_roll
          })

          console.log('✅ Device info updated with telemetry data')
        }
      }
    }, { deep: true })

    // Also watch for OSD visibility changes to update when device changes
    watch(() => osdVisible.value, (newOsd) => {
      if (newOsd.visible && newOsd.sn) {
        console.log('🔄 OSD changed to device:', newOsd.sn)

        // Trigger telemetry update for the new device
        const deviceTelemetry = telemetryData.telemetryData?.[newOsd.sn]
        if (deviceTelemetry) {
          console.log('🔄 Updating deviceInfo for new OSD device')

          Object.assign(deviceInfo.device, {
            mode_code: deviceTelemetry.mode_code,
            gear: deviceTelemetry.gear,
            latitude: deviceTelemetry.latitude,
            longitude: deviceTelemetry.longitude,
            height: deviceTelemetry.height,
            elevation: deviceTelemetry.elevation,
            home_distance: deviceTelemetry.home_distance,
            horizontal_speed: deviceTelemetry.horizontal_speed,
            vertical_speed: deviceTelemetry.vertical_speed,
            battery: {
              capacity_percent: deviceTelemetry.battery?.capacity_percent,
              remain_flight_time: deviceTelemetry.battery?.remain_flight_time,
              return_home_power: deviceTelemetry.battery?.return_home_power,
              landing_power: deviceTelemetry.battery?.landing_power
            },
            position_state: {
              gps_number: deviceTelemetry.position_state?.gps_number,
              rtk_number: deviceTelemetry.position_state?.rtk_number,
              is_fixed: deviceTelemetry.position_state?.is_fixed
            },
            wind_speed: deviceTelemetry.wind_speed,
            wind_direction: deviceTelemetry.wind_direction,
            storage: deviceTelemetry.storage,
            attitude_head: deviceTelemetry.attitude_head,
            attitude_pitch: deviceTelemetry.attitude_pitch,
            attitude_roll: deviceTelemetry.attitude_roll
          })
        }
      }
    }, { deep: true })

    // In GMap.vue setup()

    // Wait for map to be ready before setting up route watcher
    const setupRouteWatcher = () => {
      watch(
        () => route.path,
        (newPath) => {
          if (newPath === '/set-waypoints') {
            useGMapManageHook.enableWaypointMode()
          } else {
            useGMapManageHook.disableWaypointMode()
          }
        },
        { immediate: true }
      )
    }

    // Listen for map ready event
    mapEventBus.on('mapReady', () => {
      // Small delay to ensure functions are stored
      setTimeout(setupRouteWatcher, 100)
    })

    function handleClickMe () {
      console.log('🗑️ Starting new grid planning, clearing existing data')

      // Clear all map layers first
      useGMapManageHook.clearAllMapLayers()

      // Also clear via flight manager if available
      if (map && leaflet) {
        console.log('flight plan clearing..')
        flightManager.clearFlightPlan(map, leaflet)
      }

      // Show area config
      showAreaConfig.setIsShow(true)
    }
    // In your GMap.vue setup() function, add these functions:

    function handleEditModeDrawing () {
      if (waylineState.isEditMode && route.path === '/area-route') {
        console.log('🔄 Enabling drawing mode for edit mode')

        // Clear any existing drawn items first
        if (state.drawnItems) {
          state.drawnItems.clearLayers()
        }

        // Enable map interactions
        const map = (root as any).$map
        if (map) {
          map.dragging.enable()
          map.touchZoom.enable()
          map.doubleClickZoom.enable()
          map.scrollWheelZoom.enable()
        }

        // Enable draw controls
        if (state.drawControl) {
          state.drawControl.enable()

          // Specifically enable the edit toolbar
          const editToolbar = state.drawControl._toolbars?.edit
          if (editToolbar) {
            editToolbar.enable()
            console.log('✅ Draw edit toolbar enabled')
          }
        }

        // If we have existing polygon data, add it to drawnItems for editing
        if (waylineState.editWaylineData) {
          const polygonState = usePolygonState()
          if (!polygonState.isPolygonFormed) {
            console.log('🔄 Setting polygon state from edit data')
            renderMissionData(waylineState.editWaylineData)

            // After rendering, ensure the polygon is added to drawnItems
            setTimeout(() => {
              addExistingPolygonToDrawnItems()
            }, 500)
          }
        }

        console.log('✅ Drawing mode fully enabled for edit mode')
      }
    }

    function addExistingPolygonToDrawnItems () {
      const map = (root as any).$map
      const leaflet = (root as any).$leaflet
      const polygonState = usePolygonState()

      if (!map || !leaflet || !polygonState.geoJsonPolygon || !state.drawnItems) {
        return
      }

      try {
        // Clear any existing layers first
        state.drawnItems.clearLayers()

        // Create a new polygon from the geoJson data and add to drawnItems
        const polygonLayer = leaflet.geoJSON(polygonState.geoJsonPolygon, {
          style: {
            color: 'blue',
            weight: 3,
            fillColor: 'blue',
            fillOpacity: 0.1,
            opacity: 0.8
          }
        })
        console.log('polygon layer in GMap:', polygonLayer)

        polygonState.polygonLayer = polygonLayer

        // Add the polygon to drawnItems for editing
        state.drawnItems.addLayer(polygonLayer)

        console.log('✅ Existing polygon added to drawnItems for editing')
      } catch (error) {
        console.error('Error adding existing polygon to drawnItems:', error)
      }
    }

    function enableDrawingMode () {
      console.log('🔄 Enabling drawing mode')

      // Make sure the draw controls are properly enabled
      const map = (root as any).$map
      if (map && state.drawControl) {
        // Re-enable the draw control
        state.drawControl.enable()

        // Specifically enable the edit toolbar
        const editToolbar = state.drawControl._toolbars?.edit
        if (editToolbar) {
          editToolbar.enable()
          console.log('✅ Draw edit toolbar enabled')
        }
      }
    }

    watch(
      () => waylineState.isEditMode,
      (newVal) => {
        console.log('Edit mode changed:', newVal)
        if (newVal && route.path === '/area-route') {
          // Call the edit mode drawing function
          handleEditModeDrawing()
          setTimeout(() => {
            handleAreaRouteNavigation()
          }, 500)
        }
      }
    )

    // Add enableDrawingMode to your state
    state.enableDrawingMode = enableDrawingMode

    function draw (
      type: MapDoodleType,
      bool: boolean,
      flightAreaType?: EFlightAreaType
    ) {
      state.currentType = type
      mouseMode.value = bool
      state.isFlightArea = !!flightAreaType

      // Convert MapDoodleEnum to string for Leaflet
      let leafletType = type
      if (type === MapDoodleEnum.PIN) leafletType = 'pin'
      else if (type === MapDoodleEnum.POLYLINE) leafletType = 'polyline'
      else if (type === MapDoodleEnum.POLYGON) leafletType = 'polygon'
      else if (type === MapDoodleEnum.CIRCLE) leafletType = 'circle'
      else if (type === MapDoodleEnum.Close) leafletType = 'off'

      useMouseToolHook.mouseTool(leafletType, getDrawCallback, flightAreaType)
    }

    // dock 控制面板
    const {
      dockControlPanelVisible,
      setDockControlPanelVisible,
      onCloseControlPanel,
    } = useDockControl()

    // 连接或断开drc
    useConnectMqtt()

    onMounted(async () => {
      await nextTick()

      // Subscribe to map events
      mapEventBus.on('mapReady', async ({ map, leaflet }) => {
        // Initialize device markers
        onMapReady({ map, leaflet })
        setupAnnotationNavigation()
        // Plot all annotations from API
        await loadAndPlotAnnotations()
      })

      mapEventBus.on('mapDestroyed', onMapDestroyed)

      // Initialize map
      const app = getApp()
      useGMapManageHook.globalPropertiesConfig(app)
    })

    watch(
      () => store.state.Layers,
      (newLayers) => {
        // Only reload if map is ready
        if (useGMapManageHook.isMapReady()) {
          loadAndPlotAnnotations()
        }
      },
      { deep: true }
    )

    onUnmounted(() => {
      // Clean up event listeners
      mapEventBus.off('mapReady', onMapReady)
      mapEventBus.off('mapDestroyed', onMapDestroyed)

      if (
        deviceTsaUpdateHook &&
        typeof deviceTsaUpdateHook.cleanup === 'function'
      ) {
        deviceTsaUpdateHook.cleanup()
      }
    })

    const { getDrawFlightAreaCallback, onFlightAreaDroneLocationWs } =
      useFlightArea()
    useFlightAreaDroneLocationEvent(onFlightAreaDroneLocationWs)

    function selectFlightAreaAction ({
      type,
      isCircle,
    }: {
      type: EFlightAreaType;
      isCircle: boolean;
    }) {
      draw(isCircle ? MapDoodleEnum.CIRCLE : MapDoodleEnum.POLYGON, true, type)
    }

    function getDrawCallback (error: any, { obj }: { obj: any }) {
      if (error) {
        console.error('Drawing error:', error)
        return
      }

      if (state.isFlightArea) {
        getDrawFlightAreaCallback(obj)
        return
      }
      switch (state.currentType) {
        case MapDoodleEnum.PIN:
          postPinPositionResource(obj)
          break
        case MapDoodleEnum.POLYLINE:
          postPolylineResource(obj)
          break
        case MapDoodleEnum.POLYGON:
          postPolygonResource(obj)
          break
        default:
          break
      }
    }
    async function postPinPositionResource (obj) {
      try {
        const req = getPinPositionResource(obj)
        setLayers(req)
        const coordinates = req.resource.content.geometry.coordinates
        updateCoordinates('gcj02-wgs84', req);
        (req.resource.content.geometry.coordinates as GeojsonCoordinate).push(
          (coordinates as GeojsonCoordinate)[2]
        )
        const result = await postElementsReq(shareId.value, req)
        obj.options.extData = { id: req.id, name: req.name }
        store.state.coverMap[req.id] = [obj]
      } catch (error) {
        console.error('Error creating pin resource:', error)
        message.error('Failed to create pin: ' + error.message)
      }
    }
    async function postPolylineResource (obj) {
      try {
        const req = getPolylineResource(obj)
        setLayers(req)
        updateCoordinates('gcj02-wgs84', req)
        const result = await postElementsReq(shareId.value, req)
        obj.options.extData = { id: req.id, name: req.name }
        store.state.coverMap[req.id] = [obj]
      } catch (error) {
        console.error('Error creating polyline resource:', error)
        message.error('Failed to create polyline: ' + error.message)
      }
    }
    async function postPolygonResource (obj) {
      try {
        const req = getPoygonResource(obj)
        setLayers(req)
        updateCoordinates('gcj02-wgs84', req)
        const result = await postElementsReq(shareId.value, req)
        obj.options.extData = { id: req.id, name: req.name }
        store.state.coverMap[req.id] = [obj]
      } catch (error) {
        console.error('Error creating polygon resource:', error)
        message.error('Failed to create polygon: ' + error.message)
      }
    }

    function getPinPositionResource (obj) {
      const position = obj.getLatLng()
      if (
        !position ||
        typeof position.lng !== 'number' ||
        typeof position.lat !== 'number'
      ) {
        throw new Error('Invalid pin position coordinates')
      }
      const resource = generatePointContent({
        lng: position.lng,
        lat: position.lat,
      })
      const name = obj.options.title || 'Pin'
      const id = uuidv4()
      return {
        id,
        name,
        resource,
      }
    }
    function getPolylineResource (obj) {
      const path = obj.getLatLngs()
      if (!path || path.length < 2) {
        throw new Error('Polyline must have at least 2 points')
      }
      const resource = generateLineContent(
        path.map((point) => ({ lng: point.lng, lat: point.lat }))
      )
      const { name, id } = getBaseInfo(obj.options)
      return {
        id,
        name,
        resource,
      }
    }
    function getPoygonResource (obj) {
      const path = obj.getLatLngs()[0] // Leaflet polygon has nested array
      if (!path || path.length < 3) {
        throw new Error('Polygon must have at least 3 points')
      }
      const resource = generatePolyContent(
        path.map((point) => ({ lng: point.lng, lat: point.lat }))
      )
      const { name, id } = getBaseInfo(obj.options)
      return {
        id,
        name,
        resource,
      }
    }
    function getBaseInfo (obj) {
      const name = obj.title || 'Element'
      const id = uuidv4()
      return { name, id }
    }
    function setLayers (resource: PostElementsBody) {
      const layers = store.state.Layers
      const layer = layers.find((item) => item.id.includes(shareId.value))
      // layer.id = 'private_layer' + uuidv4()
      // layer?.elements.push(resource)
      if (layer?.elements) {
        (layer?.elements as any[]).push(resource)
      }
      store.commit('SET_LAYER_INFO', layers)
    }
    function handleMapTypeChange (e: any) {
      const mapType = e.key
      const mapTypeNames = {
        layers: 'Layers',
        osm: 'OpenStreetMap',
        satellite: 'Satellite',
        terrain: 'Terrain',
        dark: 'Dark',
        voyager: 'Street (EN)',
      }
      currentMapType.value = mapTypeNames[mapType] || 'Satellite'
      root.$switchMapType(mapType)
    }
    function locateMe () {
      if ((root as any).$locateMe) {
        (root as any).$locateMe()
      }
    }
    function closeLivestreamOthers () {
      store.commit('SET_LIVESTREAM_OTHERS_VISIBLE', false)
    }
    function closeLivestreamAgora () {
      store.commit('SET_LIVESTREAM_AGORA_VISIBLE', false)
    }
    function updateCoordinates (transformType: string, element: any) {
      const geoType = element.resource?.content.geometry.type
      const type = element.resource?.type as number
      if (element.resource) {
        if (MapElementEnum.PIN === type) {
          const coordinates = element.resource?.content.geometry
            .coordinates as GeojsonCoordinate
          if (transformType === 'wgs84-gcj02') {
            const transResult = wgs84togcj02(
              coordinates[0],
              coordinates[1]
            ) as GeojsonCoordinate
            element.resource.content.geometry.coordinates = transResult
          } else if (transformType === 'gcj02-wgs84') {
            const transResult = gcj02towgs84(
              coordinates[0],
              coordinates[1]
            ) as GeojsonCoordinate
            element.resource.content.geometry.coordinates = transResult
          }
        } else if (MapElementEnum.LINE === type) {
          const coordinates = element.resource?.content.geometry
            .coordinates as GeojsonCoordinate[]
          if (transformType === 'wgs84-gcj02') {
            coordinates.forEach((coordinate, i, arr) => {
              arr[i] = wgs84togcj02(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate
            })
          } else if (transformType === 'gcj02-wgs84') {
            coordinates.forEach((coordinate, i, arr) => {
              arr[i] = gcj02towgs84(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate
            })
          }
          element.resource.content.geometry.coordinates = coordinates
        } else if (MapElementEnum.POLY === type) {
          const coordinates = element.resource?.content.geometry
            .coordinates[0] as GeojsonCoordinate[]
          if (transformType === 'wgs84-gcj02') {
            coordinates.forEach((coordinate, i, arr) => {
              arr[i] = wgs84togcj02(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate
            })
          } else if (transformType === 'gcj02-wgs84') {
            coordinates.forEach((coordinate, i, arr) => {
              arr[i] = gcj02towgs84(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate
            })
          }
          element.resource.content.geometry.coordinates = [coordinates]
        }
      }
    }

    function handleDeleteLastWaypoint () {
      useGMapManageHook.deleteLastWaypoint()
    }

    return {
      draw,
      mouseMode,
      drawVisible,
      livestreamOthersVisible,
      livestreamAgoraVisible,
      osdVisible,
      pin,
      state,
      M30,
      deviceInfo,
      EGear,
      EModeCode,
      str,
      EDockModeCode,
      dockControlPanelVisible,
      setDockControlPanelVisible,
      onCloseControlPanel,
      NetworkStateTypeEnum,
      NetworkStateQualityEnum,
      RainfallEnum,
      DroneInDockEnum,
      closeLivestreamOthers,
      closeLivestreamAgora,
      qualityStyle,
      selectFlightAreaAction,
      currentMapType,
      handleMapTypeChange,
      locateMe,
      handleClickMe,
      polygonState,
      router,
      showAreaConfig,
      Plane,
      Check,
      Locate,
      deviceTsaUpdateHook,
      handleDeleteLastWaypoint,
      setWaypointState,
    }
  },
})
</script>

<style lang="scss" scoped>
  /* Add these styles to your GMap.vue <style> section or your global styles */

/* Add these styles to your GMap.vue <style lang="scss" scoped> section */

/* PIN Labels - Permanent tooltips */
:deep(.pin-annotation-label) {
  background: rgba(0, 0, 0, 0.85) !important;
  border: 2px solid #2D8CF0 !important;
  border-radius: 4px !important;
  padding: 4px 10px !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  white-space: nowrap !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5) !important;
  pointer-events: none !important;
}

:deep(.pin-annotation-label::before) {
  border-top-color: rgba(0, 0, 0, 0.85) !important;
}

/* Line and Polygon Labels */
:deep(.line-polygon-label) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

:deep(.annotation-label-box) {
  background: rgba(0, 0, 0, 0.85);
  border: 2px solid #19BE6B;
  border-radius: 4px;
  padding: 4px 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  text-align: center;
  display: inline-block;
}

/* Make sure labels are above other elements but below controls */
:deep(.leaflet-tooltip-pane) {
  z-index: 650 !important;
}

:deep(.leaflet-marker-pane) {
  z-index: 600 !important;
}

/* Highlight animation */
@keyframes pulse-grow {
  0%, 100% {
    transform: scale(1);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.1;
  }
}

/* Style for tree items to show they're clickable */
.project-layer-wrapper :deep(.ant-tree-title) {
  cursor: pointer;
  transition: all 0.3s ease;
}

.project-layer-wrapper :deep(.ant-tree-node-content-wrapper:hover .ant-tree-title) {
  color: #2D8CF0 !important;
  text-shadow: 0 0 8px rgba(45, 140, 240, 0.5);
}

/* Active/selected state */
.project-layer-wrapper :deep(.ant-tree-node-selected .ant-tree-title) {
  color: #2D8CF0 !important;
  font-weight: 600 !important;
}

/* Add a subtle glow to element nodes when hovering */
.project-layer-wrapper :deep(.ant-tree-treenode:hover) {
  background: rgba(45, 140, 240, 0.05);
  border-radius: 4px;
}
.g-map-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.hide-leaflet-draw-toolbar :deep(.leaflet-draw.leaflet-control) {
  display: none !important;
}

.map-type-switcher {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 999;

  .ant-btn {
    background: #000;
    border-color: #333;
    color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

    &:hover {
      background: #333;
      border-color: #555;
      color: #fff;
    }
  }

  .ant-dropdown-menu {
    background: #000;
    border: 1px solid #333;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  }

  .ant-dropdown-menu-item {
    color: #fff;

    &:hover {
      background: #333;
      color: #fff;
    }
  }
}

.g-action-panel {
  position: absolute;
  top: 10px;
  right: 16px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.g-map-wrapper {
  height: 100%;
  width: 100%;

  .g-action-panel {
    position: absolute;
    top: 16px;
    right: 16px;
    .g-action-item {
      width: 28px;
      height: 28px;
      background: white;
      color: $primary;
      border-radius: 2px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 2px;
    }
    .g-action-item:hover {
      border: 1px solid $primary;
      border-radius: 2px;
    }
  }
  .selection {
    border: 1px solid $primary;
    border-radius: 2px;
  }

  // antd button 光晕
  &:deep(.ant-btn) {
    &::after {
      display: none;
    }
  }
}
.osd-panel {
  position: absolute;
  margin-left: 10px;
  left: 0;
  top: 10px;
  z-index: 10000;
  width: 480px;
  background: #000;
  color: #fff;
  border-radius: 2px;
  opacity: 0.8;
}
.osd > div:not(.dock-control-panel) {
  margin-top: 5px;
  padding-left: 5px;
}

.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.battery-slide {
  .capacity-percent {
    background: #00ee8b;
  }
  .return-home {
    background: #ff9f0a;
  }
  .landing {
    background: #f5222d;
  }
  .white-point {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: white;
    bottom: -0.5px;
  }
  .battery {
    background: #141414;
    color: #00ee8b;
    margin-top: -10px;
    height: 20px;
    width: auto;
    border-left: 1px solid #00ee8b;
    padding: 0 5px;
  }
}
.battery-slide > div {
  position: absolute;
  min-height: 2px;
  border-radius: 2px;
}

.liveview {
  position: absolute;
  color: #fff;
  /* Mission Control's full-screen overlay sits at z-index 9999 — this needs
     to clear that or opening it from inside Mission Control silently opens
     it behind the overlay, invisibly. */
  z-index: 10001;
  left: 0;
  margin-left: 10px;
  top: 10px;
  text-align: center;
  width: 800px;
  height: 720px;
  background: #232323;
}
</style>
/style>
